<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Access Entries'"
            [description]="'Access entries from the live access API.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
            <div class="atoku-filter-bar" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-form-field appearance="outline" class="custom-text-field atoku-search-field" floatLabel="always">
                    <mat-label>Filter entries</mat-label>
                    <input matInput (keyup)="applyTableFilter($event)" placeholder="User, door, status">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>

          <div class="radius-10 bg-white mat-elevation-z3" fxLayout="column">
            <table mat-table [dataSource]="dataSource" class="custom-table">
                <ng-container matColumnDef="table-label">
                    <th mat-header-cell class="custom-table-label" *matHeaderCellDef
                        [attr.colspan]="displayedColumns.length"> User Access Entries </th>
                </ng-container>

                <ng-container matColumnDef="userName">
                    <th mat-header-cell *matHeaderCellDef>User</th>
                    <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
                </ng-container>

                <ng-container matColumnDef="userEmail">
                    <th mat-header-cell *matHeaderCellDef>Email</th>
                    <td mat-cell *matCellDef="let row">{{ row.userEmail }}</td>
                </ng-container>

                <ng-container matColumnDef="localDateTime">
                    <th mat-header-cell *matHeaderCellDef>Date / Time</th>
                    <td mat-cell *matCellDef="let row">{{ row.localDateTime | date:'medium' }}</td>
                </ng-container>

                <ng-container matColumnDef="eventType">
                    <th mat-header-cell *matHeaderCellDef>Event</th>
                    <td mat-cell *matCellDef="let row">{{ row.eventType }}</td>
                </ng-container>

                <ng-container matColumnDef="doorName">
                    <th mat-header-cell *matHeaderCellDef>Door</th>
                    <td mat-cell *matCellDef="let row">{{ row.doorName }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="atoku-status-pill" [ngClass]="getStatusPill(row).chipClass">
                            <mat-icon [class.material-icons-outlined]="getStatusPill(row).outlined !== false">
                                {{ getStatusPill(row).icon }}
                            </mat-icon>
                            <span class="footer-default">{{ getStatusPill(row).label }}</span>
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>

          <mat-paginator #paginator class="custom-paginator" [pageSize]="10"
              [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
    </div>
</div>
